import { Directive, ElementRef, Renderer2, AfterViewInit, HostListener } from '@angular/core';

declare var $: any;

@Directive({
  selector: '[appBtnTooltipHelp]'
})
export class BtnTooltipHelpDirective implements AfterViewInit {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.initializeTooltip();
  }

  private initializeTooltip() {

    const btnTooltipHelpState = window.sessionStorage.getItem('btnTooltipHelpState');

    const wWidth = window.innerWidth;

    if ((btnTooltipHelpState || '') !== '1' && 768 <= wWidth) {
      setTimeout(() => {
        this.showTooltip();
      }, 2000);
    }
  }

  private showTooltip() {

    const tooltipElement = document.querySelector('.btn-tooltip-help');

    if (tooltipElement) {

      $(tooltipElement).popover({ boundary: 'window', html: true });
      $(tooltipElement).popover('show').addClass('disabled-normal');

      const closeButton = document.querySelector('.btn-close-tooltip');

      if (closeButton) {
        this.renderer.listen(closeButton, 'click', (event) => {
          event.preventDefault();
          console.log('here');

          $(closeButton).closest('.popover').popover('hide');
          $(tooltipElement).removeClass('disabled-normal');
          window.sessionStorage.setItem('btnTooltipHelpState', '1');
        });
      }
    }
  }

  ngOnDestroy() {

    const closeButton = document.querySelector('.btn-close-tooltip');

    if (closeButton) {
      $(closeButton).closest('.popover').popover('hide');
    }
  }
}